<div [class]="containerClass">
    <mat-form-field [class]="fieldClass">
        <mat-label appRemoveAriaOwns> {{ firstDayOfPeriodLabel | translate }} </mat-label>
        <mat-select
            required
            name="startOfWeek"
            #startOfWeek="ngModel"
            [(ngModel)]="timeOffPolicy.startOfWeek"
            placeholder="{{ firstDayOfPeriodLabel | translate }}"
            (selectionChange)="previewDataChanged()"
        >
            <mat-option *ngFor="let day of listOfWeekdays" [value]="day.value.toLowerCase()">
                {{ day.translationString | translate }}</mat-option
            >
        </mat-select>
        <mat-error *ngIf="startOfWeek.invalid">{{ startOfWeek.errors | formErrors }}</mat-error>
    </mat-form-field>
</div>
